// extracted by mini-css-extract-plugin
export default {"container":"styles_container__oVQ+E","notification":"styles_notification__su8-f","error":"styles_error__rDQtp","fadeIn":"styles_fadeIn__r5sop","fadeOut":"styles_fadeOut__65Lmr"};